export default __webpack_public_path__ + "static/media/kiss.5278e275.png";